import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames'

const IconAffiliateSVG = ({color, className, ...rest}) => {
    return (
        <svg {...rest} width="18.964" height="18.992" viewBox="0 0 18.964 18.992"
            className={classNames(['svg-icon svg-affiliate', className])}>
            <g transform="translate(0.5 0.5)">
                <path fill={color} fillRule="evenodd" stroke="rgba(0,0,0,0)" d="M946.057,1086.55a1.486,1.486,0,0,0-1.486,1.486v15.02a1.486,1.486,0,0,0,1.486,1.486h4.483a1.486,1.486,0,0,0,1.486-1.486v-.171a1.486,1.486,0,0,1,2.536-1.05l2.273,2.272a1.487,1.487,0,0,0,1.051.435h3.165a1.485,1.485,0,0,0,1.485-1.486v-3.175a1.486,1.486,0,0,0-.434-1.051l-2.288-2.288a1.486,1.486,0,0,1,1.05-2.537h.187a1.485,1.485,0,0,0,1.485-1.486v-4.484a1.485,1.485,0,0,0-1.485-1.486Z" transform="translate(-944.571 -1086.55)" />
            </g>
        </svg>
    );
};

IconAffiliateSVG.propTypes = {
    color: PropTypes.string,
    className: PropTypes.string,
};

IconAffiliateSVG.defaultProps = {
    color: '#ffffff',
    className: '',
};

export default IconAffiliateSVG;